/**
 * Локализация интерфейса: i18next + react-i18next, пять языков.
 *
 * Строки — в `locales/*.json`, по экранам (`dashboard.*`, `pocket.*` …);
 * ключи типизированы (`i18next.d.ts`): опечатка в ключе — ошибка сборки.
 * Множественное число — по правилам языка (`_one/_few/_many/_other` для
 * русского, `_one/_other` для английского, немецкого и французского,
 * `_other` для китайского): `t('pocket.count', { count })`.
 *
 * Язык берётся из `localeStore` и переключается без перезагрузки:
 * компоненты с `useTranslation` перерисовываются сами.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_UI_LANGUAGE, UI_LANGUAGES, type LanguageCode } from '@aptile/shared';

import { useLocaleStore } from '../store/localeStore';
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

export const resources = {
  ru: { translation: ru },
  en: { translation: en },
  zh: { translation: zh },
  de: { translation: de },
  fr: { translation: fr },
} as const;

function apply(language: LanguageCode): void {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: useLocaleStore.getState().uiLanguage,
  fallbackLng: DEFAULT_UI_LANGUAGE,
  supportedLngs: [...UI_LANGUAGES],
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
});
document.documentElement.lang = useLocaleStore.getState().uiLanguage;

useLocaleStore.subscribe((state, previous) => {
  if (state.uiLanguage !== previous.uiLanguage) apply(state.uiLanguage);
});

export default i18n;
